webpackJsonp([71],{

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _nl = __webpack_require__(856);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('nl', _nl2.default);

/***/ })

},[1382]);


// WEBPACK FOOTER //
// app/datetime.nl-21ca03048dfac3d92b4c.js